import { useCallback, useState } from "react";
import type { U3130ExportSommairePaiePdfRequest } from "./U3130Service";

export interface UseU3130ExportSommairePaiePdfHandlersProps {
  doExportSommairePaiePdfFn: (body: U3130ExportSommairePaiePdfRequest) => Promise<unknown>;
  onSuccess: () => void;
  onError: (params: { error: unknown }) => void;
}

export function useU3130ExportSommairePaiePdfHandlers({
  doExportSommairePaiePdfFn,
  onSuccess,
  onError,
}: UseU3130ExportSommairePaiePdfHandlersProps) {
  const [isExporting, setIsExporting] = useState(false);

  const exportSommairePaiePdf = useCallback(
    async (body: U3130ExportSommairePaiePdfRequest) => {
      if (!body.startDate?.trim() || !body.endDate?.trim()) return;
      setIsExporting(true);
      try {
        await doExportSommairePaiePdfFn(body);
        onSuccess();
      } catch (error: unknown) {
        onError({ error });
      } finally {
        setIsExporting(false);
      }
    },
    [doExportSommairePaiePdfFn, onSuccess, onError],
  );

  return { exportSommairePaiePdf, isExporting };
}
